import React, { useEffect, useState } from "react";
import { IoClose, IoEye, IoEyeOff } from "react-icons/io5";
import { getActiveDepartments, getActiveDesignations } from "../../../../services/AdminServices";
import { getAllStates, getDistrictsByState, getTalukasByDistrict } from "../../../../services/LocationService";

const initialForm = {
    name: "",
    surname: "",
    mobileNo: "",
    email: "",
    panNo: "",
    gender: "",
    dateOfBirth: "",
    departmentId: "",
    designationId: "",
    stateId: "",
    districtId: "",
    talukaId: "",
    addressLine1: "",
    addressLine2: "",
    pincode: "",
    city: "",
    // password: "",
};

const AddEmployeeFormModal = ({ open, onClose, onSave, editData }) => {

    const [form, setForm] = useState(initialForm);

    const [departments, setDepartments] = useState([]);
    const [designations, setDesignations] = useState([]);
    const [states, setStates] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [talukas, setTalukas] = useState([]);
    const [submitting, setSubmitting] = useState(false);
    // const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState("");


    const validateForm = () => {
        if (!form.name.trim()) return "Name is required";
        if (!form.surname.trim()) return "Surname is required";
        if (!form.mobileNo.trim()) return "Mobile number is required";
        if (!form.email.trim()) return "Email is required";
        if (!form.panNo.trim()) return "PAN number is required";
        
        const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i;
        if (!panRegex.test(form.panNo.trim())) {
            return "Invalid PAN Number. Format: 5 Alphabets, 4 Numbers, 1 Alphabet (e.g., ABCDE1234F)";
        }

        if (!form.departmentId) return "Please select department";
        if (!form.designationId) return "Please select designation";
        if (!form.stateId) return "Please select state";
        if (!form.districtId) return "Please select district";
        if (!form.talukaId) return "Please select taluka";
        if (!form.addressLine1.trim()) return "Address line 1 is required";
        if (!form.pincode.trim()) return "Pincode is required";
        if (!form.city.trim()) return "City is required";

        return null;
    };

    useEffect(() => {
        if (!open) {
            setForm(initialForm);
            setDistricts([]);
            setTalukas([]);
            // setShowPassword(false);
            return;
        }

        const init = async () => {
            try {
                const [deptRes, desigRes, stateList] = await Promise.all([
                    getActiveDepartments(),
                    getActiveDesignations(),
                    getAllStates(),
                ]);

                if (deptRes.success) setDepartments(deptRes.data);
                if (desigRes.success) setDesignations(desigRes.data);
                setStates(stateList);


                if (editData) {

                    if (editData?.stateId) {
                        const d = await getDistrictsByState(editData.stateId);
                        setDistricts(d);
                    }

                    if (editData?.districtId) {
                        const t = await getTalukasByDistrict(editData.districtId);
                        setTalukas(t);
                    }

                    setForm({
                        ...initialForm,
                        ...editData,
                        stateId: String(editData.stateId),
                        districtId: String(editData.districtId),
                        talukaId: String(editData.talukaId),
                        departmentId: String(editData.departmentId),
                        designationId: String(editData.designationId),
                    });
                }
            } catch (err) {
                console.error("Initialization error:", err);
            }
        };

        init();
    }, [open, editData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleStateChange = async (e) => {
        const stateId = e.target.value;

        setForm(prev => ({
            ...prev,
            stateId,
            districtId: "",
            talukaId: "",
        }));

        if (stateId) {
            const districtList = await getDistrictsByState(stateId); // ARRAY
            setDistricts(districtList);
        } else {
            setDistricts([]);
            setTalukas([]);
        }
    };

    const handleDistrictChange = async (e) => {
        const districtId = e.target.value;

        setForm(prev => ({
            ...prev,
            districtId,
            talukaId: "",
        }));

        if (districtId) {
            const talukaList = await getTalukasByDistrict(districtId); // ARRAY
            setTalukas(talukaList);
        } else {
            setTalukas([]);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        const validationError = validateForm();
        if (validationError) {
            setError(validationError);
            return;
        }

        // Prepare the payload to match the DTO exactly
        const payload = {
            ...form,
            // Ensure IDs are numbers for the Java Backend
            departmentId: Number(form.departmentId),
            designationId: Number(form.designationId),
            stateId: Number(form.stateId),
            districtId: Number(form.districtId),
            talukaId: Number(form.talukaId),
            // Ensure mobile matches the DTO field name exactly
            mobileNo: form.mobileNo,
            panNo: form.panNo.toUpperCase(),
        };

        try {
            setSubmitting(true);
            await onSave(payload);
        } catch (err) {
            setError(err?.message || "Failed to save employee");
        } finally {
            setSubmitting(false);
        }
    };

    // define genders here to make them selectable through dropdown 


    if (!open) return null;

    return (
        <div className="admin-modal-overlay">
            <div className="admin-modal">

                <div className="admin-modal-header">
                    <div className="admin-modal-title">
                        Add / Edit Employee Details
                    </div>
                    <button className="admin-modal-close" onClick={onClose}>
                        <IoClose />
                    </button>
                </div>

                <div className="admin-form-body">
                    {error && (
                        <div className="admin-error-box">
                            {error}
                        </div>
                    )}
                    <form className="admin-form-grid" onSubmit={handleSubmit}>

                        {/* NAME */}
                        <div>
                            <label className="admin-label">Name <span>*</span></label>
                            <input
                                className="admin-input"
                                name="name"
                                value={form.name}
                                onChange={handleChange}
                                placeholder="Enter Name"
                                required
                            />
                        </div>

                        {/* SURNAME */}
                        <div>
                            <label className="admin-label">Surname <span>*</span></label>
                            <input
                                className="admin-input"
                                name="surname"
                                value={form.surname}
                                onChange={handleChange}
                                placeholder="Enter Surname"
                                required
                            />
                        </div>
                        {/* DOB */}
                        <div>
                            <label className="admin-label">Date of Birth <span>*</span></label>
                            <input
                                className="admin-input"
                                type="date"
                                name="dateOfBirth"
                                value={form.dateOfBirth}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        {/* GENDER */}
                        <div>
                            <label className="admin-label">Gender <span>*</span></label>
                            <select
                                className="admin-input"
                                name="gender"
                                value={form.gender}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select Gender</option>
                                <option value="MALE">Male</option>
                                <option value="FEMALE">Female</option>
                                <option value="OTHER">Other</option>
                            </select>
                        </div>

                        {/* MOBILE */}
                        <div>
                            <label className="admin-label">Mobile No <span>*</span></label>
                            <input
                                className="admin-input"
                                name="mobileNo"
                                value={form.mobileNo}
                                onChange={handleChange}
                                placeholder="Enter Mobile Number"
                                maxLength={10}
                                required
                            />
                        </div>

                        {/* EMAIL */}
                        <div>
                            <label className="admin-label">Email Id <span>*</span></label>
                            <input
                                className="admin-input"
                                type="email"
                                name="email"
                                value={form.email}
                                onChange={handleChange}
                                placeholder="Enter Email Id"
                                required
                            />
                        </div>
                        {/* Pan no */}
                        <div>
                            <label className="admin-label">PAN Number <span>*</span></label>
                            <input
                                className="admin-input uppercase"
                                name="panNo"
                                value={form.panNo}
                                onChange={handleChange}
                                placeholder="Enter PAN Number"
                                maxLength={10}
                                required
                            />
                        </div>


                        {/* DEPARTMENT */}
                        <div>
                            <label className="admin-label">Department <span>*</span></label>
                            <select
                                className="admin-input"
                                name="departmentId"
                                value={form.departmentId}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select Department</option>
                                {departments.map(d => (
                                    <option key={d.id} value={d.id}>
                                        {d.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* DESIGNATION */}
                        <div>
                            <label className="admin-label">Designation <span>*</span></label>
                            <select
                                className="admin-input"
                                name="designationId"
                                value={form.designationId}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select Designation</option>
                                {designations.map(d => (
                                    <option key={d.id} value={d.id}>
                                        {d.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* STATE */}
                        <div>
                            <label className="admin-label">State <span>*</span></label>
                            <select
                                className="admin-input"
                                name="stateId"
                                value={form.stateId}
                                onChange={handleStateChange}
                                required
                            >
                                <option value="">Select State</option>
                                {states.map(s => (
                                    <option key={s.id} value={s.id}>{s.name}</option>
                                ))}
                            </select>
                        </div>

                        {/* DISTRICT */}
                        <div>
                            <label className="admin-label">District <span>*</span></label>
                            <select
                                className="admin-input"
                                name="districtId"
                                value={form.districtId}
                                onChange={handleDistrictChange}
                                required
                            >
                                <option value="">Select District</option>
                                {districts.map(d => (
                                    <option key={d.id} value={d.id}>
                                        {d.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* TALUKA */}
                        <div>
                            <label className="admin-label">Taluka <span>*</span></label>
                            <select
                                className="admin-input"
                                name="talukaId"
                                value={form.talukaId}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select Taluka</option>
                                {talukas.map(t => (
                                    <option key={t.id} value={t.id}>
                                        {t.name}
                                    </option>
                                ))}
                            </select>
                        </div>



                        {/* ADDRESS LINE 2 */}
                        <div>
                            <label className="admin-label">Address Line 1</label>
                            <input
                                className="admin-input"
                                name="addressLine1"
                                value={form.addressLine1}
                                onChange={handleChange}
                                placeholder="Enter Address Line 2"
                            />
                        </div>

                        {/* ADDRESS LINE 2 */}
                        <div>
                            <label className="admin-label">Address Line 2</label>
                            <input
                                className="admin-input"
                                name="addressLine2"
                                value={form.addressLine2}
                                onChange={handleChange}
                                placeholder="Enter Address Line 2"
                            />
                        </div>

                        {/* CITY */}
                        <div>
                            <label className="admin-label">City <span>*</span></label>
                            <input
                                className="admin-input"
                                name="city"
                                value={form.city}
                                onChange={handleChange}
                                placeholder="Enter City"
                                required
                            />
                        </div>

                        {/* PINCODE */}
                        <div>
                            <label className="admin-label">Pincode <span>*</span></label>
                            <input
                                className="admin-input"
                                name="pincode"
                                value={form.pincode}
                                onChange={handleChange}
                                placeholder="Enter Pincode"
                                maxLength={6}
                                required
                            />
                        </div>


                    </form>
                </div>

                <div className="admin-form-footer">
                    <button className="admin-btn-cancel" onClick={onClose}>
                        CANCEL
                    </button>
                    <button className="admin-btn-save" disabled={submitting} onClick={handleSubmit}>
                        {submitting ? "Saving..." : "SAVE"}
                    </button>
                </div>

            </div>
        </div>
    )
}

export default AddEmployeeFormModal;